/* Promo countdown. Generalised from the Labor Day banner script: three states,
   the warm-up window before the discount opens (prices stay full, CSS handles
   that via body[data-sale]), the live sale, and after. Dates and copy come from
   data attributes on [data-promo-countdown] so each promo is just settings. */
(() => {
  const roots = document.querySelectorAll('[data-promo-countdown]');
  if (!roots.length) return;

  const pad = (n) => String(n).padStart(2, '0');

  roots.forEach((root) => {
    const start = new Date(root.dataset.start);
    const end = new Date(root.dataset.end);
    if (isNaN(start) || isNaN(end)) return;

    const lead = root.querySelector('[data-cd-lead]');
    const units = {
      d: root.querySelector('[data-cd="d"]'),
      h: root.querySelector('[data-cd="h"]'),
      m: root.querySelector('[data-cd="m"]'),
      s: root.querySelector('[data-cd="s"]'),
    };

    const tick = () => {
      const now = Date.now();
      const state = now < start ? 'soon' : now < end ? 'live' : 'ended';
      document.body.dataset.sale = state;
      root.dataset.state = state;

      if (state === 'ended') {
        if (lead) lead.textContent = root.dataset.endedText || '';
        clearInterval(timer);
        return;
      }

      const left = (state === 'soon' ? start : end) - now;
      if (lead) lead.textContent = state === 'soon' ? root.dataset.soonText : root.dataset.liveText;
      units.d.textContent = pad(Math.floor(left / 864e5));
      units.h.textContent = pad(Math.floor(left / 36e5) % 24);
      units.m.textContent = pad(Math.floor(left / 6e4) % 60);
      units.s.textContent = pad(Math.floor(left / 1e3) % 60);
    };

    const timer = setInterval(tick, 1000);
    tick();
  });
})();
